import React from 'react';
import { motion } from 'framer-motion';

const cn = (...classes) => classes.filter(Boolean).join(' ');

export const BackgroundLines = ({ children, className = '', svgOptions }) => {
    return (
        <div className={cn('h-[20rem] md:h-screen w-full', className)}>
            <SVG svgOptions={svgOptions} />
            {children}
        </div>
    );
};

const pathVariants = {
    initial: { strokeDashoffset: 800, strokeDasharray: '50 800' },
    animate: {
        strokeDashoffset: 0,
        strokeDasharray: '20 800',
        opacity: [0, 1, 1, 0],
    },
};

const SVG = ({ svgOptions }) => {
    const paths = [
        'M720 450C720 450 742.459 440.315 755.249 425.626C768.039 410.937 778.88 418.741 789.478 401.499C800.076 384.258 817.06 389.269 826.741 380.436C836.423 371.603 851.957 364.826 863.182 356.242C874.408 347.657 877.993 342.678 898.867 333.214C919.741 323.75 923.618 319.88 934.875 310.177C946.133 300.474 960.784 300.837 970.584 287.701C980.384 274.564 993.538 273.334 1004.85 263.087C1016.15 252.84 1026.42 250.801 1038.22 242.1C1050.02 233.399 1065.19 230.418 1074.63 215.721C1084.07 201.024 1085.49 209.128 1112.65 194.884C1139.8 180.64 1132.49 178.205 1146.43 170.636C1160.37 163.066 1168.97 158.613 1181.46 147.982C1193.95 137.35 1191.16 131.382 1217.55 125.645C1243.93 119.907 1234.19 118.899 1254.53 100.846C1274.86 82.7922 1275.12 92.8914 1290.37 76.09C1305.62 59.2886 1313.91 62.1868 1323.19 56.7536C1332.48 51.3204 1347.93 42.8082 1361.95 32.1468C1375.96 21.4855 1374.06 25.168 1397.08 10.1863C1420.09 -4.79534 1421.41 -3.16992 1431.52 -15.0078',
        'M720 450C720 450 741.044 435.759 753.062 410.636C765.079 385.514 770.541 386.148 782.73 370.489C794.918 354.83 799.378 353.188 811.338 332.597C823.298 312.005 825.578 306.419 843.707 295.493C861.837 284.568 856.194 273.248 877.376 256.48C898.558 239.713 887.536 227.843 909.648 214.958C931.759 202.073 925.133 188.092 941.063 177.621C956.994 167.151 952.171 154.663 971.197 135.041C990.222 115.418 990.785 109.375 999.488 96.1291C1008.19 82.8827 1011.4 82.2181 1032.65 61.8861C1053.9 41.5541 1045.74 48.0281 1064.01 19.5798C1082.29 -8.86844 1077.21 -3.89415 1093.7 -19.66C1110.18 -35.4258 1105.91 -46.1146 1127.68 -60.2834C1149.46 -74.4523 1144.37 -72.1024 1154.18 -97.6802C1163.99 -123.258 1165.6 -111.332 1186.21 -135.809C1206.81 -160.285 1203.29 -160.861 1220.31 -177.633C1237.33 -194.406 1236.97 -204.408 1250.42 -214.196',
        'M720 450C720 450 712.336 437.768 690.248 407.156C668.161 376.544 672.543 394.253 665.951 365.784C659.358 337.316 647.903 347.461 636.929 323.197C625.956 298.933 626.831 303.639 609.939 281.01C593.048 258.381 598.7 255.282 582.342 242.504C565.985 229.726 566.053 217.66 559.169 197.116C552.284 176.572 549.348 171.846 529.347 156.529C509.345 141.211 522.053 134.054 505.192 115.653C488.33 97.2527 482.671 82.5627 473.599 70.7833C464.527 59.0039 464.784 50.2169 447 32.0721C429.215 13.9272 436.29 0.858563 423.534 -12.6868C410.777 -26.2322 407.424 -44.0808 394.364 -56.4916C381.303 -68.9024 373.709 -72.6804 365.591 -96.1992C357.473 -119.718 358.364 -111.509 338.222 -136.495C318.08 -161.481 322.797 -149.499 315.32 -181.761C307.843 -214.023 294.563 -202.561 285.795 -223.25C277.026 -243.94 275.199 -244.055 258.602 -263.871',
    ];

    const colors = [
        '#47BF72', '#22d3ee', '#47BF72', '#3aa85f', '#22d3ee', '#47BF72', '#22d3ee', '#3aa85f', '#47BF72', '#22d3ee', '#3aa85f', '#47BF72', '#22d3ee', '#47BF72', '#3aa85f', '#22d3ee', '#47BF72', '#3aa85f', '#22d3ee', '#47BF72', '#3aa85f',
    ];

    return (
        <motion.svg
            viewBox="0 0 1440 900"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
            className="absolute inset-0 w-full h-full pointer-events-none"
        >
            {paths.map((path, idx) => (
                <motion.path
                    key={`path-first-${idx}`}
                    d={path}
                    stroke={colors[idx % colors.length]}
                    strokeWidth="2.3"
                    strokeLinecap="round"
                    variants={pathVariants}
                    initial="initial"
                    animate="animate"
                    transition={{
                        duration: (svgOptions?.duration || 10),
                        ease: 'linear',
                        repeat: Infinity,
                        repeatType: 'loop',
                        delay: Math.floor(Math.random() * 10),
                        repeatDelay: Math.floor(Math.random() * 10 + 2),
                    }}
                />
            ))}
            {paths.map((path, idx) => (
                <motion.path
                    key={`path-second-${idx}`}
                    d={path}
                    stroke={colors[idx % colors.length]}
                    strokeWidth="2.3"
                    strokeLinecap="round"
                    variants={pathVariants}
                    initial="initial"
                    animate="animate"
                    transition={{
                        duration: (svgOptions?.duration || 10),
                        ease: 'linear',
                        repeat: Infinity,
                        repeatType: 'loop',
                        delay: Math.floor(Math.random() * 10),
                        repeatDelay: Math.floor(Math.random() * 10 + 2),
                    }}
                />
            ))}
        </motion.svg>
    );
};

export default BackgroundLines;
